export enum ProgressBarFormat {
  RAW = 'raw',
  PERCENT = 'percent'
}
